import styles from './AnimatedIcon.scss';

import { IPlayerProps, Player } from '@lottiefiles/react-lottie-player';
import cx from 'classnames';
import React, { forwardRef } from 'react';

export interface AnimatedIconProps extends Omit<IPlayerProps, 'src'> {
  src?: object | string;
  children?: never;
  ariaLabel?: string;
}

export const AnimatedIcon = forwardRef<Player, AnimatedIconProps>(({
  className,
  src,
  ariaLabel,
  ...props
}, ref) => {
  if (!src) return null;

  return (
    <i
      {...{
        'aria-label': ariaLabel,
        'aria-hidden': !ariaLabel ? true : undefined,
        'role': ariaLabel ? 'img' : undefined,
      }}
    >
      <Player
        ref={ref}
        src={src}
        className={cx(styles.animatedIcon, className)}
        {...props}
      />
    </i>
  );
});
